import React, { memo } from 'react'
import type { PLLHit } from '../types'
import {
  ResultRow,
  ResultLogo,
  ResultInfo,
  ResultName,
  ResultChevron,
} from '../styles'
import { HighlightedText } from './HighlightedText'

type TeamResultItemProps = {
  item: PLLHit
  query: string
  onSelect: () => void
}

export const TeamResultItem = memo<TeamResultItemProps>(({ item, query, onSelect }) => {
  const handleKeyDown = (e: React.KeyboardEvent): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onSelect()
    }
  }

  return (
    <ResultRow
      role="option"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={handleKeyDown}
      aria-label={`${item.title}, PLL Team`}
    >
      {item.image && <ResultLogo src={item.image} alt="" loading="lazy" />}
      <ResultInfo>
        <ResultName>
          <HighlightedText text={item.title || ''} query={query} />
        </ResultName>
      </ResultInfo>
      <ResultChevron aria-hidden="true">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M9 18l6-6-6-6" />
        </svg>
      </ResultChevron>
    </ResultRow>
  )
})

TeamResultItem.displayName = 'TeamResultItem'
